export default function is_null(obj) {
    return obj == null || obj == undefined
}
